import type { JSX } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { DateRangeFilterValue } from '@/shared/types/table-filters.types';

export interface DateRangeFilterProps {
  id: string;
  label: string;
  value: DateRangeFilterValue;
  onChange: (value: DateRangeFilterValue | undefined) => void;
}

function nextRange(
  current: DateRangeFilterValue,
  bound: 'from' | 'to',
  raw: string
): DateRangeFilterValue | undefined {
  const next = { ...current, [bound]: raw || undefined };
  return (next.from ?? next.to) ? next : undefined;
}

export function DateRangeFilter({ id, label, value, onChange }: DateRangeFilterProps): JSX.Element {
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={`${id}-from`}>{label}</Label>
      <div className="flex items-center gap-2">
        <Input
          id={`${id}-from`}
          type="date"
          aria-label={`Filter by ${label} from`}
          value={value.from ?? ''}
          onChange={(event) => onChange(nextRange(value, 'from', event.target.value))}
          className="w-full sm:w-[150px]"
        />
        <span className="text-muted-foreground text-sm">–</span>
        <Input
          id={`${id}-to`}
          type="date"
          aria-label={`Filter by ${label} to`}
          value={value.to ?? ''}
          onChange={(event) => onChange(nextRange(value, 'to', event.target.value))}
          className="w-full sm:w-[150px]"
        />
      </div>
    </div>
  );
}
